<!--
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2024-03-07 17:04:35
 * @FilePath: \js-yigrow-system\src\components\common\toolbar-title.vue
 * @Description: 常规全屏编辑框顶部标题
-->
<template>
  <div>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="!isEmpty(closeText)">
        <v-btn @click="$emit('save')">
          {{ closeText }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script setup>
import { isEmpty } from '@/utils/common-utils'
defineProps({
  title: {
    type: String,
    default: "",
    require: true,
  },
  closeText: {
    type: String,
    default: "",
    require: true,
  },
})
const emit = defineEmits(["close", "save"])
</script>

<style scoped></style>
